import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';    // Sử dụng Container của Bootstrap
import { Form, Input, Button, DatePicker, Select } from 'antd'; // Sử dụng thành phần của Ant Design
import ManagerService from '../../services/ManagerService';
import ReturnButton from "./ReturnButton";

const { TextArea } = Input;  // TextArea để nhập nội dung chi tiết

const SuaChuaBaoDuongComponent = ({ setComponentDuocChon }) => {
  const [form] = Form.useForm();  // Tạo instance form của AntD
  const [dsTaiXe, setDsTaiXe] = useState([]);  // Dữ liệu tài xế (options cho Select)
  const [tramOptions, setTramOptions] = useState([]); //Dữ liệu các trạm bảo dưỡng - sửa chữa

  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const data = await ManagerService.Lay_DS_Taixe(); 
        if (data && data.data) {
          const options = data.data.map(item => ({
            value: item.username,
            label: `${item.name} - (${item.sdt})`
          }));
          setDsTaiXe(options);
        }
      } catch (error) {
        console.error('Lỗi khi lấy danh sách tài xế:', error);
      }
    };

    const fetchRepairs = async () => {
      try {
        const data = await ManagerService.Lay_DS_Tram(); 
        if (data && data.data) {
          const options = data.data.map(item => ({
            value: item.value,
            label: item.label
          }));
          setTramOptions(options);
        }
      } catch (error) {
        console.error('Lỗi khi lấy danh sách trạm:', error);
      }
    };

    fetchDrivers();
    fetchRepairs();
  }, []);

  // Các giá trị tùy chọn
  const loaiOptions = [
    { value: 'sua-chua', label: 'Sửa chữa' },
    { value: 'bao-duong', label: 'Bảo dưỡng' },
    { value: 'thay-nhot', label: 'Thay nhớt' },
    { value: 'thay-lop', label: 'Thay lốp' },
    { value: 'thay-acquy', label: 'Thay acquy' }
  ];

  // Submit form
  const handleSubmit = async (values) => {
    try {
      // values = { loai, bienKiemSoat, ngaySuaChua, donGia, taiXe, tram, chiTietNoiDung }
      const payload = {
        loai: values.loai,
        bienKiemSoat: values.bienKiemSoat,
        ngaySuaChua: values.ngaySuaChua
          ? values.ngaySuaChua.format('YYYY-MM-DD')  // chuyển DatePicker sang string
          : '',
        donGia: values.donGia,
        taiXe: values.taiXe,
        tram: values.tram,
        chiTietNoiDung: values.chiTietNoiDung
      };

      const response = await ManagerService.submitSuaChuaBaoDuong(payload);
      alert(response.message || 'Đã gửi dữ liệu thành công');
      form.resetFields(); // reset form
    } catch (error) {
      console.error('Lỗi khi gửi dữ liệu:', error);
      alert('Không thể gửi dữ liệu sửa chữa và bảo dưỡng. ' + error.message);
    }
  };

  return (
    <Container className="mt-5">
      <ReturnButton setComponentDuocChon={setComponentDuocChon} />

      <h2 className="text-center mb-4">
        Tạo đơn đi Bảo dưỡng - Sửa chữa
      </h2>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit} 
        // onFinishFailed={} // nếu muốn handle lỗi
      >
        {/* Loại */}
        <Form.Item 
          label="Loại"
          name="loai"
          rules={[{ required: true, message: 'Vui lòng chọn loại!' }]}
        >
          <Select
            placeholder="Chọn loại..."
            options={loaiOptions}
          />
        </Form.Item>

        {/* Biển kiểm soát */}
        <Form.Item
          label="Biển kiểm soát"
          name="bienKiemSoat"
          rules={[{ required: true, message: 'Vui lòng nhập biển kiểm soát!' }]}
        >
          <Input placeholder="Nhập biển kiểm soát" />
        </Form.Item>

        {/* Ngày sửa chữa (DatePicker) */}
        <Form.Item
          label="Ngày sửa chữa"
          name="ngaySuaChua"
          rules={[{ required: true, message: 'Vui lòng chọn ngày sửa chữa!' }]}
        >
          <DatePicker
            style={{ width: '100%' }}
            placeholder="Chọn ngày"
            // Chúng ta dùng dayjs thay cho moment
          />
        </Form.Item>

        {/* Tài xế */}
        <Form.Item
        label="Chọn Tài xế gửi"
        name="taiXe"
        rules={[{ required: true, message: 'Vui lòng chọn tài xế!' }]}
        >
        <Select
            placeholder="Chọn tài xế"
            options={dsTaiXe}
            showSearch
            optionFilterProp="label"
            filterOption={(input, option) =>
            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        />
        </Form.Item>

        {/* Trạm */}
        <Form.Item
          label="Trạm"
          name="tram"
          rules={[{ required: true, message: 'Vui lòng chọn trạm!' }]}
        >
          <Select
            placeholder="Chọn trạm..."
            options={tramOptions}
          />
        </Form.Item>

        {/* Chi tiết nội dung */}
        <Form.Item
          label="Chi tiết nội dung sửa chữa"
          name="chiTietNoiDung"
          rules={[{ required: true, message: 'Vui lòng nhập nội dung sửa chữa!' }]}
        >
          <TextArea rows={4} placeholder="Nhập chi tiết nội dung sửa chữa" />
        </Form.Item>

        {/* Nút Gửi */}
        <Form.Item>
          <Button 
            type="primary"
            htmlType="submit"
            className="w-100"
          >
            Gửi
          </Button>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default SuaChuaBaoDuongComponent;
